




















import { Component } from 'vue-property-decorator';
import SearchResultsBaseComponent from '@/components/SearchResults/SearchResultsBaseComponent.vue';
import SearchResultElement from '@/models/SearchResultElement';
import { SearchGetter } from '@/store/getters';

@Component({
  name: 'content-list-component',
})
export default class ContentListComponent extends SearchResultsBaseComponent {
  get searchResults(): Array<SearchResultElement> {
    return this.$store.getters[SearchGetter.SearchResults].length
      ? this.$store.getters[SearchGetter.SearchResults]
      : this.$store.getters[SearchGetter.SearchSuggestions].elements;
  }
}
